import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';

@Directive({
  selector: '[appHasRole]'
})
export class HasRoleDirective implements OnInit {

  @Input('appHasRole') roles: string[] = [];

  constructor(
    private authService: AuthService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
    ) { }

  ngOnInit() {
    let aTF: any[] = [];
    if (this.authService.authenticated && this.authService.currentUser && this.roles !== null) {
      // console.log(this.roles);
      if (this.authService.hasRoles(this.roles)) {
        let exist = false;
        aTF.forEach( a => {
          if (a.elementRef === this.templateRef.elementRef) {
            exist = true;
          }
        });
        if (!exist) {
          aTF.push(this.templateRef);
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      } else {
        aTF = [];
        this.viewContainer.clear();
      }
    }
  }
}
